/**
 * Assignment template lookup helpers for document/report forms.
 * Prefer sdk.assignmentTemplate / assignmentTemplateIntegration for CRUD.
 */
import { sdk } from '@/lib/api/sdk-instance.js';
import { Logger } from '@/lib/app-log.js';

const emptyPage = (page = 1, pageSize = 10) => ({
    data: [],
    pagination: {
        totalRecords: 0,
        totalPages: 0,
        currentPage: page,
        pageSize,
    },
    uniqueValues: {},
});

export const fetchAssignmentTemplates = async (params = {}) => {
    const page = params.page || 1;
    const pageSize = params.pageSize || 100;
    try {
        const query = {
            page,
            pageSize,
            sortBy: params.sortBy || 'name',
            sortOrder: params.sortOrder || 'asc',
            ...(params.search ? { search: params.search } : {}),
        };
        const res = await sdk.assignmentTemplate.getAll(query);
        const list = Array.isArray(res?.data) ? res.data : [];
        const meta = res?.pagination || {};
        return {
            data: list,
            pagination: {
                totalRecords: meta.total ?? meta.totalRecords ?? list.length,
                totalPages: meta.totalPages ?? 0,
                currentPage: meta.page ?? page,
                pageSize: meta.pageSize ?? pageSize,
            },
            uniqueValues: res?.uniqueValues || {},
        };
    } catch (error) {
        Logger.error('[assignment-template] fetch failed', { error: error?.message });
        return emptyPage(page, pageSize);
    }
};

export const createAssignmentTemplate = async (data) => sdk.assignmentTemplate.create(data);

export const updateAssignmentTemplate = async (id, data) => sdk.assignmentTemplate.update(id, data);

export const deleteAssignmentTemplate = async (id) => sdk.assignmentTemplate.delete(id);

/** Thin adapter for callers that expect a raw HTTP-style API object. */
export const assignmentTemplateApi = {
    getAll: (params = {}) => sdk.assignmentTemplate.getAll(params),
    getById: (id) => sdk.assignmentTemplate.getById(id),
    getUnitHeadOptions: () => sdk.assignmentTemplate.getUnitHeadOptions(),
    create: (data) => sdk.assignmentTemplate.create(data),
    update: (id, data) => sdk.assignmentTemplate.update(id, data),
    delete: (id) => sdk.assignmentTemplate.delete(id),
    preview: (data) => sdk.assignmentTemplate.preview(data),
};
